import { render, staticRenderFns } from "./ConversionRateChart.vue?vue&type=template&id=0637c834&scoped=true&"
import script from "./ConversionRateChart.vue?vue&type=script&lang=js&"
export * from "./ConversionRateChart.vue?vue&type=script&lang=js&"
import style0 from "./ConversionRateChart.vue?vue&type=style&index=0&id=0637c834&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0637c834",
  null
  
)

export default component.exports